import { useEffect } from "react";
import PremiumBenefits from "./PremiumBenefits";
import PremiumPlans from "./PremiumPlans";
import Styles from "./styles.module.css";
import UserReviews from "./UserReviews";
import { triggerEvent } from "../../constants/utils";

const PremiumScreen = () => {
  useEffect(()=>{
    triggerEvent("Premium_Plans");
  }, []);
  
  return (
    <div className={Styles.PremiumScreenContainer2}>
      <div className={Styles.PremiumScreenContainer}>
        <img
          src={require("../../assets/payment_screen/paywall_new.png")}
          className={Styles.PremiumCoverImage}
        />
        <img
          src={require("../../assets/payment_screen/apple_laurel.png")}
          className={Styles.GooglePlayAward}
        />
        <PremiumPlans />
      </div>
      {/* <PremiumBenefits />
      <UserReviews /> */}
    </div>
  );
};

export default PremiumScreen;
